module.exports = __webpack_public_path__ + "static/media/cameraIcon.2ba73041.svg";